module.exports = __webpack_public_path__ + "img/DAY6-2.0862575a.jpg";